// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import { TrackingTrigger, TrackingProvider } from '@indeed/flex-tracking-context'

import PageView from 'syft-acp-core/components/PageView'
import WorkerDetail from 'syft-acp-core/entities/WorkerDetail/WorkerDetail'
import { trackingEvents } from 'syft-acp-core/entities/WorkerDetail/WorkerDetail.tracking'
import { recordLabel, useWorkerName } from 'syft-acp-core/components/PageTitle'
import { WorkerSubNavigation } from './SubNavigation'

export const EntityWorkersView = ({ match: { params } }) => {
  const workerName = useWorkerName(Number(params.id))

  return (
    <>
      <TrackingProvider
        value={{
          context: {
            worker_id: params.id,
          },
        }}
      >
        <TrackingTrigger
          onLoad={{
            event: trackingEvents.PAGE.VIEWED,
          }}
        />
        <WorkerSubNavigation workerID={params.id} />
        <PageView title={[recordLabel('Worker', params.id, workerName)]}>
          <WorkerDetail id={Number(params.id)} />
        </PageView>
      </TrackingProvider>
    </>
  )
}
